module.exports = __webpack_public_path__ + "img/logo-star-and-garter.856b0b64.jpg";